import { useState, useEffect } from "react";
import { Customer } from "../types/restaurant";
import api from "../../../../../../features/auth/axiosConfig";
import { useUser } from "src/business-types/grocery/components/UserContext";

export const useCustomerManagement = () => {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [filteredCustomers, setFilteredCustomers] = useState<Customer[]>([]);
  const [pagenumber, setPagenumber] = useState<number>(1);
  const{userConfigration}=useUser()
  const [pageSize] = useState<number>(userConfigration?.tableDefultSize || 10);
  const [total, setTotal] = useState({
    totalRecords: "",
    totalPage: "",
  });
  const [customerName, setCustomerName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [tableNumber, setTableNumber] = useState("");
  const [customerAdd, setCustomerAdd] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const fetchCustomerDetails = async () => {
    try {
      const response = await api.get(`/app/v1/pos/customer?include_deleted=False&pageNumber=${pagenumber}&pageSize=${pageSize}&searchBy=${searchTerm}`);
      const data = response.data;

      setCustomers(response.data.customer_details || []);
      setFilteredCustomers(response.data.customer_details || []);
      setTotal({
        totalRecords: data.totalRecords,
        totalPage: String(Math.ceil(Number(data.totalRecords) / pageSize)),
      });
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  // Add this effect to trigger API call when searchTerm changes
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchCustomerDetails();
    }, 500); // Debounce search

    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, pagenumber]);

  return {
    customers,
    filteredCustomers,
    setFilteredCustomers,
    pagenumber,
    setPagenumber,
    total,
    customerName,
    setCustomerName,
    phoneNumber,
    setPhoneNumber,
    tableNumber,
    setTableNumber,
    customerAdd,
    setCustomerAdd,
    searchTerm,
    setSearchTerm,
    fetchCustomerDetails,
    pageSize, // Export pageSize if needed
  };
};